import { createStore } from 'zustand/vanilla'
import { BULLET_LIMIT } from '../constants/constants'
import { SlideshowFromDirection } from '../types/Slideshow'

export type BulletIndexState = {
	index: number
	firstBulletIndex: number
	lastBulletIndex: number
}
interface BulletIndexActions {
	rollLimitIndex: (
		fromDirection: SlideshowFromDirection,
		numberOfBullets: number
	) => void
}

export type BulletIndexStore = BulletIndexState & BulletIndexActions

export const defaultInitState: BulletIndexState = {
	index: 0,
	firstBulletIndex: 0,
	lastBulletIndex: 4,
}

export const createBulletIndexStore = (
	initState: BulletIndexState = defaultInitState
) =>
	createStore<BulletIndexStore>()((set) => ({
		...initState,
		rollLimitIndex: (
			fromDirection: SlideshowFromDirection,
			numberOfBullets: number
		) =>
			set((state) => ({
				index: getBulletIndex(numberOfBullets, state)[fromDirection],
				firstBulletIndex: getFirstBulletIndex(numberOfBullets, state)[
					fromDirection
				],
				lastBulletIndex: getLastBulletIndex(numberOfBullets, state)[
					fromDirection
				],
			})),
	}))

const getFirstBulletIndex = (
	numberOfBullets: number,
	state: BulletIndexState
) => {
	const loopLeftEdgeMove =
		numberOfBullets <= BULLET_LIMIT ? 0 : numberOfBullets - BULLET_LIMIT

	const edgeOnLeftMove =
		state.index - 1 === state.firstBulletIndex && state.index - 1 > 0
			? state.firstBulletIndex - 1
			: state.firstBulletIndex

	const edgeOnRightMove =
		state.index + 1 === state.lastBulletIndex &&
		state.index + 1 < numberOfBullets - 1
			? state.firstBulletIndex + 1
			: state.firstBulletIndex

	return {
		[SlideshowFromDirection.Left]:
			state.index === 0 ? loopLeftEdgeMove : edgeOnLeftMove,
		[SlideshowFromDirection.Right]:
			state.index === numberOfBullets - 1 ? 0 : edgeOnRightMove,
	}
}

const getLastBulletIndex = (
	numberOfBullets: number,
	state: BulletIndexState
) => {
	const rightEdgeMove =
		numberOfBullets <= BULLET_LIMIT ? numberOfBullets - 1 : BULLET_LIMIT - 1

	const edgeOnLeftMove =
		state.index - 1 === state.firstBulletIndex && state.index - 1 > 0
			? state.lastBulletIndex - 1
			: state.lastBulletIndex

	const edgeOnRightMove =
		state.index + 1 === state.lastBulletIndex &&
		state.index + 1 < numberOfBullets - 1
			? state.lastBulletIndex + 1
			: state.lastBulletIndex

	return {
		[SlideshowFromDirection.Left]:
			state.index === 0 ? numberOfBullets - 1 : edgeOnLeftMove,
		[SlideshowFromDirection.Right]:
			state.index === numberOfBullets - 1 ? rightEdgeMove : edgeOnRightMove,
	}
}

const getBulletIndex = (numberOfBullets: number, state: BulletIndexState) => ({
	[SlideshowFromDirection.Left]:
		state.index === 0 ? numberOfBullets - 1 : state.index - 1,
	[SlideshowFromDirection.Right]:
		state.index === numberOfBullets - 1 ? 0 : state.index + 1,
})
